import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import TextField from '@mui/material/TextField';
import { media } from '../shared/styles/media';
import { StyledFlex } from '../shared/styles/styled';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledAuthRoot = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${({ theme }) => `${theme.colors.white}`};
  @media (max-height: 760px) {
    height: auto;
  }
`;

export const StyledAuthContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: grid;
  place-items: start;
  align-content: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  @media (max-height: 760px) {
    height: auto;
  }
`;

export const StyledLoginCardContainer = styled.div`
  z-index: 1;
  animation: ${fadeIn} ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  @media (max-height: 760px) {
    margin-top: ${({ marginTop }) => marginTop || '40px'};
  }
`;

export const StyledLoginCardContent = styled(StyledFlex)`
  padding: 40px;
  background: ${({ theme }) => theme.colors.white};
  z-index: 2;
  border-radius: 20px;
  width: 550px;
  box-shadow: ${({ theme }) => theme.boxShadows.loginCardShadow};

  ${media.sm} {
    width: 516px;
  }

  ${media.xs} {
    width: 411px;
  }
`;

export const StyledTemplateContent = styled(StyledFlex)`
  padding: 20px;
  background: ${({ theme }) => theme.colors.white};
  z-index: 2;
  border-radius: 15px;
  width: 406px;
  box-shadow: ${({ theme }) => theme.boxShadows.loginCardShadow};
  gap: 20px;

  ${media.sm} {
    width: 381px;
  }
  ${media.xs} {
    width: 303px;
  }
`;

export const StyledLoginFailed = styled.section`
  margin: 0;
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  border: 1px solid ${({ theme }) => theme.colors.validationError};
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 0 0 4px ${({ theme }) => theme.colors.lightRedError} inset;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.validationError};
  padding: 18px 14px;
  pointer-events: none;
`;

export const StyledFailIcon = styled.div`
  flex: 0 0 auto;
  margin: 0 16px;

  & > svg {
    font-size: 24px;
  }
`;

export const StyledTextLoginField = styled(TextField)`
  & .MuiInputBase-root {
    height: 50px;
    border-radius: 8px;
    font-family: 'Montserrat', sans-serif;
  }
`;

export const StyledAuthFooter = styled(StyledFlex)`
  width: 100%;
  height: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: fixed;
  bottom: 0;

  @media (max-height: 760px) {
    position: relative;
  }
`;

export const StyledTemplateImage = styled('img')(({ theme }) => ({
  position: 'relative',
  maxWidth: '366px',
  maxHeight: '169px',
  borderRadius: '10px',
  objectFit: 'contain',

  '&::after': {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    backgroundColor: theme.colors.white,
    fontFamily: 'Montserrat',
    fontWeight: 700,
    lineHeight: '20px',
    textAlign: 'center',
    content: 'attr(alt)',
  },
}));
